export const COMPONENTS_MAPPING = {
  "@/views/reports/LiveDashboard.vue": () =>
    import("@/views/reports/LiveDashboard.vue"),
  "@/views/reports/LiveAcquisition.vue": () =>
    import("@/views/reports/LiveAcquisition.vue"),
  "@/views/reports/powerbi/Generic.vue": () =>
    import("@/views/reports/powerbi/Generic.vue"),
  "@/views/reports/powerbi/GenericEmbedded.vue": () =>
    import("@/views/reports/powerbi/GenericEmbedded.vue"),
  "@/views/reports/powerbi/PerformanceReportEmbedded.vue": () =>
    import("@/views/reports/powerbi/PerformanceReportEmbedded.vue"),
  "@/views/reports/TodayStatistics.vue": () =>
    import("@/views/reports/TodayStatistics.vue"),
  "@/views/tools/PlayerTracker.vue": () =>
    import("@/views/tools/PlayerTracker.vue"),
  "@/views/tools/PlayerSearch.vue": () =>
    import("@/views/tools/PlayerSearch.vue"),
  "@/views/SupplierAndGameRequests.vue": () =>
    import("@/views/SupplierAndGameRequests.vue"),
  "@/views/LatestNews.vue": () => import("@/views/LatestNews.vue"),
  "@/views/news/NewsCategory.vue": () =>
    import("@/views/news/NewsCategory.vue"),
  "@/views/news/NewsItem.vue": () => import("@/views/news/NewsItem.vue"),
  "@/views/Games.vue": () => import("@/views/Games.vue"),
  "@/views/GamesNewVersion.vue": () => import("@/views/GamesNewVersion.vue"),
  "@/views/games/SingleGame.vue": () => import("@/views/games/SingleGame.vue"),
  "@/views/RTPVariants.vue": () => import("@/views/RTPVariants.vue"),
  "@/views/GameAssets.vue": () => import("@/views/GameAssets.vue"),
  "@/views/game-assets/GameAssets.vue": () =>
    import("@/views/game-assets/GameAssets.vue"),
  "@/views/documents/Onboarding.vue": () =>
    import("@/views/documents/Onboarding.vue"),
  "@/views/JackpotsAndPromos.vue": () =>
    import("@/views/JackpotsAndPromos.vue"),
  "@/views/Social.vue": () => import("@/views/Social.vue"),
  "@/views/Iframe.vue": () => import("@/views/Iframe.vue"),
  "@/views/PartnerAdmin.vue": () => import("@/views/PartnerAdmin.vue"),
  "@/views/administration/CreateUserView.vue": () =>
    import("@/views/administration/CreateUserView.vue"),
  "@/views/administration/ManageUsersView.vue": () =>
    import("@/views/administration/ManageUsersView.vue"),
  "@/views/Help.vue": () => import("@/views/Help.vue"),
  "@/views/user/Profile.vue": () => import("@/views/user/Profile.vue"),
  "@/views/PageNotFound.vue": () => import("@/views/PageNotFound.vue"),
  "@/views/documents/CMS.vue": () => import("@/views/documents/CMS.vue"),
  "@/views/documents/Elite.vue": () => import("@/views/documents/Elite.vue"),
  "@/views/documents/Evolve.vue": () => import("@/views/documents/Evolve.vue"),
  "@/views/status/Elite.vue": () => import("@/views/status/Elite.vue"),
  "@/views/status/PAM.vue": () => import("@/views/status/PAM.vue"),
  "@/views/Page.vue": () => import("@/views/Page.vue"),
  "@/views/TradingOverview.vue": () => import("@/views/TradingOverview.vue"),
  "@/views/GenericDropBox.vue": () => import("@/views/GenericDropBox.vue"),
};
